import React from 'react';
import { socialProof } from '../data/content';
export function SocialProof() {
  return <section aria-label="Community proof" className="border-b border-navy-700 bg-navy-900" data-id="element-178" data-mp="3ltdsc5ojntvn">
      <ul className="mx-auto grid max-w-page grid-cols-2 gap-x-4 gap-y-6 px-4 py-8 sm:grid-cols-3 sm:gap-y-8 sm:px-5 sm:py-10 lg:grid-cols-5 lg:gap-x-8" data-id="element-179" data-mp="36vttlgi8quxx">
        {socialProof.map(item => <li key={item.stat} className="border-l-2 border-gold/40 pl-4" data-id="element-180" data-mp="3ev7l0v8owgt">
            <p className="font-display text-xl font-extrabold tracking-[-0.02em] text-gold sm:text-2xl" data-id="element-181" data-mp="3gy320f5vhsx">
              {item.stat}
            </p>
            <p className="mt-2 text-xs leading-snug text-mist" data-id="element-182" data-mp="3pv7r28f6int6">{item.label}</p>
          </li>)}
      </ul>
    </section>;
}